module.exports = __webpack_public_path__ + "img/stock6.81b6d731.png";